export type ThemeId = "dark" | "light";

export type ThemeDefinition = {
  id: ThemeId;
  label: string;
  description: string;
};

export const themes: ThemeDefinition[] = [
  {
    id: "dark",
    label: "Night",
    description: "Low-light canvas-first palette.",
  },
  {
    id: "light",
    label: "Day",
    description: "Bright editorial palette.",
  },
];

export const defaultTheme: ThemeId = "dark";
export const themeStorageKey = "ux-eye-candy-theme";

export function isThemeId(value: string | null): value is ThemeId {
  return themes.some((theme) => theme.id === value);
}
